export const SECTION_HEADER = 'External Page';
export const TOOLTIP_DESCRIPTION =
  'This will open a separate webpage to provide more details. This field is not required.';
export const INTERACTION_LABEL = 'External Page URL';
